export default "__VITE_ASSET__BTX9GTwZ__"